//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../DesignSimulation/DesignSimulation.ContourSettingsBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"ColorDisplayStyle",1,1],[0,"ContourDisplayStyle",1,1],[0,"ContourLimit",1,0],[0,"Material",1,"Material",1],[0,"MaterialLimit",1,1],[0,"MaterialLimitBody",1,"DesignSimulation.AnalysisBody",0],[1,"MaxStressCompression",0,"Expression",0],[1,"MaxStressTension",0,"Expression",0],[0,"NaturalFrequenciesCount",0,1],[0,"NaturalFrequencyIndex",1,1],[0,"ResultComponent",1,1],[1,"YieldStrength",0,"Expression",0]],[[["frequrncyIndex"],"IsNaturalFrequencySelectedForAnimation",{R_:{isFrequencySelected:''}},1,1],[["frequencyIndex","isFrequencySelected"],"SetNaturalFrequencySelectedForAnimation",{},2,1],[["frequrncyIndex"],"IsFrequencySelectedForAnimation",{R_:{isFrequencySelected:''}},1,0],[["frequencyIndex","isFrequencySelected"],"SetFrequencySelectedForAnimation",{},2,0]],[]];
SPLM.DesignSimulation.ResultSettingsBuilder = class extends SPLM.DesignSimulation.ContourSettingsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ResultSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;